import React from "react";
import { IoMdNotificationsOutline } from "react-icons/io";
import { PiMagnifyingGlassLight } from "react-icons/pi";
import PostComponent from "../components/Post";
import { IconButton } from "@mui/material";
import { RxHamburgerMenu } from "react-icons/rx";
import { useNavigate } from "react-router-dom";
import supabase from "../utils/supabase";
import { useEffect, useState } from "react";
import { HashLoader } from "react-spinners";
import logo from "../assets/logo.png"; // Add this import
import { format } from "timeago.js";

// To delete content

function Social() {
  const navigate = useNavigate();
  const [dbPosts, setDbPosts] = useState([]);

  useEffect(() => {
    async function fetchPosts() {
      const { data, error } = await supabase
        .from("posts")
        .select("id, created_at, user_id, likes, content, title, user_info"); // added user_info here

      if (error) {
        console.error("Error fetching posts:", error);
      } else {
        console.log("Posts from database:", data);
        setDbPosts(data);
      }
    }

    fetchPosts();
  }, []);

  const processPost = (post) => {
    return {
      id: post.id,
      name: post.user_info?.name || "Anonymous User",
      role: post.user_info?.role || "Unknown Role",
      ago: format(new Date(post.created_at)), // This will show "2 hours ago", "5 minutes ago", etc.
      projectDeck: "#",
      // removed static profilePic as it's now generated in PostComponent
      post: post.content,
      likes: post.likes || 0,
      comments: 0,
      title: post.title || "Untitled Post",
      user_id: post.user_id,
    };
  };

  return (
    <div className="page nav-exists">
      <div className="header flex items-center justify-between p-4 bg-[#f9f9f9] fixed top-0 lg:left-[250px] w-full lg:w-[calc(100%-250px)] z-[100] border-b-2 border-b-gray-200">
        <div className="lg:invisible flex items-center justify-center w-16 h-16 flex-shrink-0">
          <img src={logo} alt="Logo" className="w-14 h-14 object-contain" />
        </div>

        <div className="flex items-center bg-gray-100 rounded-lg px-3 py-2 mx-2 lg:mx-auto border border-black flex-1 max-w-md">
          <PiMagnifyingGlassLight
            size={20}
            className="text-gray-600 mr-2 flex-shrink-0"
          />
          <input
            type="text"
            name="search"
            id="search-input"
            placeholder="Search"
            className="bg-transparent outline-none w-full min-w-0"
          />
        </div>

        <IconButton className="flex-shrink-0">
          <IoMdNotificationsOutline size={30} className="text-gray-600" />
        </IconButton>
      </div>

      {/* Content with adjusted top padding */}
      <div className="mt-32 lg:mt-36 lg:max-w-4xl lg:mx-auto">
        <div className="posts">
          {dbPosts.length > 0 ? (
            dbPosts.map((post) => (
              <PostComponent key={post.id} {...processPost(post)} />
            ))
          ) : (
            <div className="flex justify-center items-center p-10">
              <HashLoader color="#0072ff" />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Social;
